<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.cost_cacl')">
        <CostCaclEdit></CostCaclEdit>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.cost_compare')">
        <CostCaclSearch></CostCaclSearch>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import CostCaclEdit from './CostCaclEdit.vue';
import CostCaclSearch from './CostCaclSearch.vue';
export default {
  components: {
    CostCaclEdit,
    CostCaclSearch
  },
  data() {
    return {
      tab_index: 0
    }
  },
}
</script>
